<template>
  <div>
    <CRow>
      <CCol sm="12" class="p-0">
        <CCard>
          <div
            class="px-3 d-flex flex-wrap w-100 border-bottom align-items-center"
          >
            <h5 class="flex-grow-1 col-xs-6 my-2">Operativos</h5>
            <DateSelector
              initDates="week"
              :date="this.initDates"
              @input="e => changeDate(e)"
              class="margi-dates z-custom-2 col-xs-6 my-2"
            />
            <div class="d-flex flex-wrap col-xs-12 my-2">
              <v-select
                class="selector-input"
                :options="cultivos"
                v-model="cropGraphs"
                :loading="isLoadingPage"
                placeholder="Cultivo"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="variedadesPorCultivo"
                v-model="variedadGraphs"
                :loading="isLoadingPage"
                placeholder="Variedad"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="embalajesPorCultivo"
                v-model="embalajeGraphs"
                :loading="isLoadingPage"
                :multiple="true"
                placeholder="Embalaje"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
              <v-select
                class="selector-input"
                :options="ubicaciones2"
                v-model="locationGraphs"
                :loading="isLoadingPage"
                placeholder="Ubicacion"
              >
                <template #open-indicator="{ attributes }">
                  <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                </template>
                <template #no-options>Sin resultados.</template>
              </v-select>
            </div>
          </div>
          <CCardBody class="p-0 pt-2">
            <CNav justified variant="tabs">
              <CNavItem :to="{
            name: 'ProduccionIndicador'
          }">Producción</CNavItem>
              <CNavItem
                :to="{
            name: 'ProduccionIndicadorAcumulada'
          }"
              >Producción Acumulada</CNavItem>
              <CNavItem :to="{
            name: 'CantidadAct'
          }">Cantidad por Actividad</CNavItem>
              <CNavItem
                :to="{
            name: 'CantidadActAcumulados'
          }"
              >Cant X Act Acumulada</CNavItem>
              <CNavItem
                :to="{
            name: 'IndicadoresOperativos'
          }"
                active
              >KPI's Operativos</CNavItem>
            </CNav>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">KPI's</CCardHeader>

          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CCardGroup v-else class="mb-4">
              <CWidgetProgressIcon
                :header="$formatter(produccionEq ? String(produccionEq.cantidad_eq) : `0`)"
                text="Producción total"
                color="info"
                inverse
              >
                <template #progress>
                  <div></div>
                </template>
                <CIcon name="cil-basket" height="48" />
              </CWidgetProgressIcon>

              <CWidgetProgressIcon
                :header="$formatter(entregasEq ? `${String(entregasEq.cantidad_eq)}` : `0`)"
                text="Entrega total"
                color="dark"
                inverse
              >
                <template #progress>
                  <div></div>
                </template>
                <CIcon name="cil-basket" height="48" />
              </CWidgetProgressIcon>
            </CCardGroup>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">Producción</CCardHeader>
          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              small
              :items="itemsProduccion"
              :fields="fieldsProduccion"
              :noItemsView="noItems"
              pagination
            >
              <template #cultivo="{item}">
                <td class="py-2">
                  {{ `${item.cultivo} ${item.variedad}` }}
                </td>
              </template>
              <template #kilos="{item}">
                <td class="py-2">
                  {{ $formatter(item.peso) }}
                </td>
              </template>
              <template #piezas="{item}">
                <td class="py-2">
                  {{ $formatter(item.cantidad) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">Entregas</CCardHeader>
          <CCardBody>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoadingPage"
            >
              <div class="sk-flow d-flex align-items-center">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              small
              :items="itemsEntregas"
              :fields="fieldsEntregas"
              :noItemsView="noItems"
              pagination
            >
              <template #cultivo="{item}">
                <td class="py-2">
                  {{ `${item.cultivo} ${item.variedad}` }}
                </td>
              </template>
              <template #cantidad_eq="{item}">
                <td class="py-2">
                  {{ $formatter(item.cantidad_eq) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DateSelector from "../../../customComponents/DateSelector";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import axios from "axios";

const fieldsEntregas = [
  { key: "cultivo", label: "Producto", _style: "width:33%" },
  { key: "embalaje", label: "Embalaje", _style: "width:33%" },
  { key: "cantidad_eq", label: "Piezas", _style: "width:33%" }
];

const fieldsProduccion = [
  { key: "cultivo", label: "Producto", _style: "width:25%" },
  { key: "embalaje", label: "Embalaje", _style: "width:25%" },
  { key: "kilos", label: "Kilos", _style: "width:25%" },
  { key: "piezas", label: "Piezas", _style: "width:25%" }
];

const fieldsCostos = [
  { key: "concepto", label: "Concepto", _style: "width:33%" },
  { key: "categoria_raiz", label: "Categoria", _style: "width:33%" },
  { key: "total", label: "Total", _style: "width:33%" }
];

const fieldsKPI = [
  { key: "nombre", label: "Etapa", _style: "width:16%" },
  { key: "pre_util", label: "Presupuesto utilizado", _style: "width:16%" },
  { key: "presupuesto", label: "Presupuesto", _style: "width:16%" },
  { key: "porcentaje", label: "%", _style: "width:16%" },
  { key: "fecha_inicial", label: "Fecha inicio", _style: "width:18%" },
  { key: "fecha_final", label: "Fecha fin", _style: "width:18%" }
];

export default {
  name: "IndicadoresOperativos",
  components: {
    vSelect,
    DateSelector
  },

  data() {
    return {
      options: ["hola", "adios"],
      cultivo: null,
      cultivos: [],
      cultivosAll: [],
      lote: null,
      lotes: [],
      lotesAll: [],
      loteSelect: null,
      itemsEntregas: [],
      fieldsEntregas,
      itemsProduccion: [],
      fieldsProduccion,
      itemsCostos: [],
      fieldsCostos,
      itemsKPI: [],
      fieldsKPI,
      counter: 85,
      variedades: [],
      variedadGraphs: null,
      embalajes: [],
      embalajeGraphs: [],
      ubicaciones2: [],
      ubicacion2: null,
      lotesPresupuesto: null,
      produccionEq: null,
      entregas: null,
      entregasEq: null,
      costos: null,
      costos_lotes: null,
      isLoadingPage: false,
      isLoteActive: false,
      costos_dia: [],
      dayValues: [],
      labels: [],
      color1: "primary",
      color2: "secondary",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      data: [],
      dataBar: [],
      cancelSource: null,
      // date selector
      isCustomOpen: false,
      dates: {},
      selectedDate: {
        // start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        // end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      }
    };
  },

  created() {
    this.fetchCombos();
    this.updateAllInfo();
  },

  computed: {
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    costoCaja() {
      if (this.costos && this.produccionEq) {
        if (this.costos.total > 0 && this.produccionEq.cantidad_eq > 0) {
          return String(
            (this.costos.total / this.produccionEq.cantidad_eq).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    roi() {
      if (this.costos && this.entregas) {
        if (this.costos.total > 0 && this.entregas.total > 0) {
          return String(
            ((this.entregas.total / this.costos.total) * 100).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    productividadVsObjetivo() {
      if (this.lote && this.loteSelect && this.produccionEq) {
        if (
          this.produccionEq.cantidad_eq > 0 &&
          this.loteSelect.payload.produccion_objetivo > 0
        ) {
          return String(
            (
              (this.produccionEq.cantidad_eq /
                this.loteSelect.payload.produccion_objetivo) *
              100
            ).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    ingresosVsObjetivo() {
      if (this.lote && this.loteSelect && this.entregas) {
        if (
          this.entregas.total > 0 &&
          this.loteSelect.payload.produccion_objetivo > 0
        ) {
          return String(
            (
              (this.entregas.total /
                this.loteSelect.payload.ingresos_objetivo) *
              100
            ).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    presupuestoUtilizado() {
      if (this.lote && this.loteSelect && this.costos) {
        let presupuestoLote = 0;
        this.loteSelect.payload.etapas.length > 0
          ? (presupuestoLote = this.loteSelect.payload.etapas.reduce(
              (acum, etapa) => acum + etapa.presupuesto,
              0
            ))
          : (presupuestoLote = 0);

        if (this.costos.total > 0 && presupuestoLote > 0) {
          return String(
            ((this.costos.total / presupuestoLote) * 100).toFixed(2)
          );
        }
        return "0";
      }
      return "0";
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    initDates() {
      return {
        start: moment(this.datesGraph[0]),

        end: moment(this.datesGraph[1])
      };
    },
    cropGraphs: {
      get() {
        return this.$store.state.cropGraphs;
      },
      set(value) {
        this.$store.dispatch("setCropGraph", value);
      }
    },
    locationGraphs: {
      get() {
        return this.$store.state.locationGraphs || this.$store.state.rootLocation;
      },
      set(value) {
        this.$store.dispatch("setLocationGraph", value);
      }
    },
    datesGraph() {
      return this.$store.state.dateGraphs;
    },
    variedadesPorCultivo() {
      const cultivo = this.cropGraphs
      return cultivo === null ? [] : this.variedades.filter(variedad => {
        return cultivo.label === variedad.cultivo
      });
    },
    embalajesPorCultivo() {
      return this.cropGraphs ? this.cropGraphs.embalajes : []
    },
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateAllInfo();
      this.fetchCombos();
    },
    cropGraphs: function() {
      this.updateAllInfo();
    },
    variedadGraphs: function() {
      this.updateAllInfo();
    },
    embalajeGraphs: {
      deep: true,
      handler() {
        this.updateAllInfo()
      }
    },
    locationGraphs: function() {
      this.updateAllInfo();
    },
    datesGraph: function() {
      this.updateAllInfo();
    }
  },

  methods: {
    customOpenDateSelector() {
      this.isCustomOpen = !this.isCustomOpen;
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    getCostoLote(etapa) {
      if (this.costos_lotes && this.lote) {
        const etapaSelect = this.costos_lotes.find(
          costo => costo.etapa == etapa
        );

        if (etapaSelect) {
          return etapaSelect.total;
        }
        return 0;
      }
      return 0;
    },
    getCostoLotePorcentaje(etapa, presupuesto) {
      let presupuestoUtilizadoEtapa = this.getCostoLote(etapa);

      if (presupuestoUtilizadoEtapa > 0 && presupuesto > 0) {
        return ((presupuestoUtilizadoEtapa / presupuesto) * 100).toFixed(2);
      }
      return 0;
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive ? (this.cultivo = null) : (this.lote = null);
    },
    updateValues() {
      // this.updateGraphs();
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        // this.updateItemsSearch(this.filter.toUpperCase());
        // this.updateInfo();
        this.isLoteActive
          ? this.updateValuesLote()
          : this.updateValuesCultivo();
      }, 800);
    },
    updateAllInfo() {
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      this.isLoadingPage = true;
      this.itemsEntregas = [];
      this.itemsProduccion = [];

      const params = {
        fecha: this.datesGraph,
        ...(this.cropGraphs ? {
          cultivo: this.cropGraphs.value,
          cultivo_id: this.variedadGraphs ? this.variedadGraphs.value : '',
          embalaje: this.embalajeGraphs || []
        } : {}),
        ...(this.locationGraphs ? { ubicacion: this.locationGraphs.value } : {}),
        ubicaciones: [this.ubicacionRaiz]
      };

      const indicadores = [
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "producciones_cultivo_embalaje",
            params
          },
          cancelToken: this.cancelSource
        }),
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "entregas_cultivo_embalaje",
            params
          },
          cancelToken: this.cancelSource
        }),
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "producciones_eq",
            params
          },
          cancelToken: this.cancelSource
        }),
        this.$store.dispatch("customIndicadoresHTTP", {
          body: {
            reporte: "entregas_eq",
            params
          },
          cancelToken: this.cancelSource
        })
      ];

      Promise.all(indicadores)
        .then(([produccionCultivos, entregasCultivos, produccionE, entregasE]) => {
          this.itemsProduccion = produccionCultivos.data;
          this.itemsEntregas = entregasCultivos.data;
          this.produccionEq = produccionE.data;
          this.entregasEq = entregasE.data;
          this.isLoadingPage = false;
        })
        .catch(err => {
          if (err !== "Stop") {
            this.isLoadingPage = false;
          }
        });
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Stop");
        // console.log("cancel request done");
      }
    },
    fetchCombos() {
      this.isLoadingPage = true;
      // // console.log(moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59"));
      // if (!this.ubicacionesRaiz.length) {
      const ubi = [
        this.$store.dispatch('customHTTP', {
          schema: 'configuracion',
          filter: {
            where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
          }
        }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->pertenece_id",
                value: 0,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }),
        this.$store.dispatch("customHTTP", { schema: "cultivos" }),
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaiz,
                operator: "="
              },
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      Promise.all(ubi)
        .then(([configuracion, ubicaciones, cultivos, ubicacionesAll]) => {
          // console.log(ubicaciones.data);
          this.ubicaciones = ubicaciones.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          this.cultivos = configuracion.data[0].payload.valor.map((cultivo, ) => {
            return {label: cultivo.nombre, value: cultivo.nombre, embalajes: cultivo.embalajes }
          })
          this.variedades = cultivos.data.map(cultivo => {
            return { value: cultivo.id, label: cultivo.payload.variedad, cultivo: cultivo.payload.nombre};
          }).filter(variedad => {
            return variedad.label != undefined
          });
          this.ubicaciones2 = ubicacionesAll.data.map(ubi => {
            return { value: ubi.id, label: ubi.payload.nombre };
          });
          // console.log(values);
          // this.ubicaciones = ubicaciones.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoadingPage = false));
    },
    changeDate(e) {
      const datesValues = [
        moment(e.start).format("YYYY-MM-DD"),
        moment(e.end).format("YYYY-MM-DD")
      ];
      this.$store.dispatch("setDateGraph", datesValues);
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.txt-purple {
  color: #321fdb;
}
.txt-green {
  color: #2eb85c !important;
}
.txt-red {
  color: #e55353 !important;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.dropdown-sp {
  width: 400px;
}
.cursor-p {
  cursor: pointer;
}
/* .btn-header {
  max-width: 120px;

} */

.root-location {
  width: 180px;
  margin: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selector-input {
  width: 180px;
  margin-left: 0.5rem;
}
.selector-input-2 {
  width: 180px;
  margin: 0 0.5rem;
}
.root-location-input {
  width: 100%;
}
.margi-dates {
  margin: 0 0.5rem;
}
.sp-margin-b {
}
.sp-margin-ul {
}
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
/* .btn-header {
  max-width: 120px;
} */
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
@media (max-width: 700px) {
  .selector-input {
    width: 180px;
    margin-left: 0.5rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0 0.5rem;
  }
  .margi-dates {
    margin: 0 0.4rem;
  }
}
@media (max-width: 620px) {
  .selector-input {
    width: 200px;
    margin-right: 0.4rem;
  }
  .selector-input-2 {
    width: 200px;
    margin: 0.4rem;
  }
}
@media (max-width: 580px) {
  .margi-dates {
    margin: 0 0.3rem;
  }
  .selector-input {
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
}
@media (max-width: 450px) {
  .root-location {
    width: 120px;
    margin: 0 0.2rem;
  }
  .sp-margin-b {
    margin-left: 0.5rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.5rem !important;
  }
}
@media (max-width: 360px) {
  .root-location {
    width: 100px;
    margin: 0 0.2rem;
  }
  .sp-font-size {
    font-size: 10px;
    font-weight: 400;
  }
  .sp-margin-b {
    margin-left: 0.1rem !important;
  }
  .sp-margin-ul {
    margin-right: 0.1rem !important;
  }
  .clave {
    font-size: 11px;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
